<template>
    <div class="contact-cell" @mouseenter="showMenu = true" @mouseleave="hideMenu">
        <div v-if="contact" class="contact-info" @click="viewContactProfile(contact)">
            <div class="contact-avatar">
                <PlatformIconViewer :platform="contact.platform" />
            </div>
            <span class="contact-name">{{ contact.fullname }}</span>
        </div>
        <PermissionController :permissions="['table.update']" v-else>
            <a @click="showContactPicker">+ Kişi Ekle</a>
        </PermissionController>
        <div class="contact-menu" @mouseenter="cancelHide" @mouseleave="hideMenu" v-if="showMenu && contact">
            <PermissionController :permissions="['table.update']">
                <SupsisButton icon="edit" @click="editContact" xxsmall />
            </PermissionController>
            <PermissionController :permissions="['table.update']">
                <SupsisButton icon="delete" @click="removeContact" xxsmall />
            </PermissionController>
        </div>
        <Modal2
            v-if="showModal"
            @cancel="closeModal"
            :title="'Kişi Seç'"
            :okText="'Kaydet'"
            xlarge
            className="contact-picker-modal keydown-prevent-modal"
        >
            <List picker-mode @select="onContactSelected" />
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import Modal2 from "../../../../../components/common/Modal2.vue";
import List from "../../../Visitors/List.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import PlatformIconViewer from "../../../../../components/common/PlatformIconViewer.vue";
import { mapActions } from "vuex";

export default Vue.extend({
    name: "ContactCell",
    components: {
        Modal2,
        List,
        SupsisButton,
        PlatformIconViewer,
    },
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: false,
            showMenu: false,
            hideTimeout: null,
        };
    },
    computed: {
        contact() {
            const contactId = this.record.data[this.field._id];
            if (typeof contactId === "string") {
                return this.$store.state.visitor.visitors.data.find((contact) => contact._id === contactId) || null;
            }
            return contactId || null;
        },
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
        }),
        viewContactProfile(contact) {
            this.addNewWindow({
                type: "show-visitor",
                title: contact.fullname,
                payload: {
                    visitorId: contact._id,
                },
                footer: false,
                autoClose: false,
            });
        },
        showContactPicker() {
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        async onContactSelected(contact) {
            try {
                await this.$emit("update-record", {
                    recordId: this.record._id,
                    fieldId: this.field._id,
                    value: contact._id,
                });
                this.closeModal();
            } catch (error) {
                console.error("Kayıt güncellenirken hata oluştu:", error);
                this.$message.error("Kayıt güncellenirken bir hata oluştu");
            }
        },
        editContact() {
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            this.showContactPicker();
        },
        async removeContact() {
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            try {
                await this.$emit("update-record", {
                    recordId: this.record._id,
                    fieldId: this.field._id,
                    value: null,
                });
                this.$message.success("Kişi başarıyla kaldırıldı");
            } catch (error) {
                console.error("Kişi kaldırılırken hata oluştu:", error);
                this.$message.error("Kişi kaldırılırken bir hata oluştu");
            }
        },
        hideMenu() {
            this.hideTimeout = setTimeout(() => {
                this.showMenu = false;
            }, 200);
        },
        cancelHide() {
            clearTimeout(this.hideTimeout);
        },
    },
});
</script>

<style scoped lang="scss">
.contact-cell {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;

    .contact-info {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;
        transition: background-color 0.2s ease;

        &:hover {
            background: var(--color-bg-neutral-hover);
        }

        .contact-avatar {
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background: var(--color-bg-neutral-hover);
        }
    }

    .contact-name {
        font-weight: 500;
    }

    .contact-menu {
        position: absolute;
        right: -14px;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 0.3s ease;
        z-index: 10;
        height: 100%;
        width: max-content;
        background: #0000002b;
        display: flex;
        justify-content: flex-end;
        gap: 5px;
        align-items: center;
        padding: 0 10px;
    }
}
</style>
